<template>
  <section>
    <div class="top">
    </div>
    <div class="bottom goldBg">
      <div class="container">
        <h2>Our Story Begins with a Pressing Need</h2>
        <p><strong>Our Mission:</strong> Pencils for Kids, Inc. is dedicated to helping children in need in developing countries to attend school and, in doing so, build the foundation for a better future. We partner with other like-minded individuals, organizations and corporate sponsors to fulfill this mission. We believe that, working together, we can transform the world, one child at a time.</p>
        <div class="text-center"><router-link to="/our-story" class="btn btn-lg btn-primary">More Stories</router-link></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'our-story'
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';
  section {
    display: flex;
    flex-direction: column;
    .top {
      height: 250px;
      @include media('tablet') {
        height: 350px;
      }
      background-image: url('~assets/images/PFK_Photo2_StoryBegins_2000x500.jpg');
      background-size: cover;
    }
    .bottom {
      padding: 80px 0;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// OurStory.vue?2c7839a4